import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import {
  Text,
  FlatList,
  StyleSheet,
  View,
  TouchableOpacity,
  LayoutAnimation,
  Platform,
} from "react-native";

import ActivityItem from "./ActivityItem";
import Collapsible from "../../common/Collapsible/Collapsible";
import Icons from "../../common/icons/index";
import { isWeb } from "../../../../helpers/utils";

let ActivitiesList = (props) => {
  const {
    title,
    activities,
    initialNumToRender,
    contentType = "activities",
  } = props;

  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [expandedList, setExpandedList] = useState(false);
  const [activitiesList, setActivitiesList] = useState([]);
  const [message, setMessage] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [initialNumberToRender] = useState(initialNumToRender);

  // Swipe buttons
  const [currentlyOpenSwipeable, setCurrentlyOpenSwipeable] = useState(null);

  useEffect(() => {
    let results = activities;

    if (hasMoreItems && results.length > initialNumberToRender) {
      setActivitiesList(results.slice(0, initialNumberToRender));
      setHasMoreItems(true);
      setMessage(
        results.length - initialNumberToRender + ` more ${contentType}`,
      );
    } else {
      setActivitiesList(results);
      setHasMoreItems(false);
    }
  }, [activities]);

  const showMore = () => {
    setActivitiesList(activities.slice(0));
    setExpandedList(true);
    setHasMoreItems(false);
  };

  const toggleExpand = () => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setIsCollapsed(!isCollapsed);
  };

  // Swipe buttons
  const itemProps = {
    onOpen: (event, gestureState, swipeable) => {
      if (currentlyOpenSwipeable) {
        currentlyOpenSwipeable.recenter();
      }

      setCurrentlyOpenSwipeable(swipeable);
    },
    onClose: () => {
      setCurrentlyOpenSwipeable(null);
    },
  };

  function renderItem({ item, index }) {
    return (
      <ActivityItem
        key={item.id}
        item={{ ...item, index }}
        {...itemProps}
        {...props}
      />
    );
  }

  return (
    <View>
      {title ? (
        <TouchableOpacity style={styles.sectionHeader} onPress={toggleExpand}>
          <Text style={styles.header}>{title}</Text>
          <Icons.Collapse
            style={styles.collapseIcon}
            isCollapsed={isCollapsed}
          />
        </TouchableOpacity>
      ) : null}

      <Collapsible isCollapsed={isCollapsed}>
        {expandedList && activitiesList.length > 100 ? (
          <FlatList
            style={isWeb ? { height: 450 } : {}}
            data={activitiesList}
            maxToRenderPerBatch={15}
            windowSize={15}
            keyExtractor={(item, index) => item.id}
            renderItem={renderItem}
          />
        ) : (
          <View style={styles.listContainer}>
            {activitiesList.map((item, index) => renderItem({ item, index }))}
            {hasMoreItems ? (
              <View style={styles.moreWrapper}>
                <Icons.MoreItems showMore={showMore} message={message} />
              </View>
            ) : null}
          </View>
        )}
      </Collapsible>
    </View>
  );
};

ActivitiesList.propTypes = {
  activities: PropTypes.array.isRequired,
  initialNumToRender: PropTypes.number.isRequired,
  controller: PropTypes.object.isRequired,
  showEditOptions: PropTypes.func,
  contentType: PropTypes.oneOf(["activities", "Favorites", "recommendations"]),
};

const styles = StyleSheet.create({
  sectionHeader: {},
  header: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: "#2D3142",
    display: "flex",
    alignItems: "center",
    paddingLeft: 15,
    backgroundColor: "#FFF",
  },
  listContainer: {
    position: "relative",
    width: "100%",
    height: "auto",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    borderWidth: 0,
  },
  moreWrapper: {
    paddingLeft: 20,
    marginTop: 10,
  },
});

ActivitiesList = React.memo(ActivitiesList);

export default ActivitiesList;
